import { Notification } from './notification.model';

export class Notifications {
    list: Array<Notification> = [];

    add(notification: Notification) {
        this.list.push(new Notification(notification));
        setTimeout(() => {
            this.list.splice(0, 1);
        }, 5000);
    }
}


// WEBPACK FOOTER //
// ./src/app/notification/shared/notifications.model.ts